import { useNode } from "@craftjs/core";
import { rem } from "polished";
import * as React from "react";
import styled from "styled-components";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
  BlockPaddingWrapper,
} from "@/components/editor/shared/block-wrapper";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import { Circle } from "@/components/editor/themes/hazel/shared/circle-component";
import { ColorLabels } from "@/components/editor/utils/colors";

interface Props {
  children: React.ReactNode;
}

const StyledCircleContainer = withViewportStyle("div")`
  position: absolute;
  bottom: -15%;
  left: -200px;

  ${(props) => props.$viewport.tablet`
    display: none;
  `}
`;

const StyledCircle = styled(Circle).attrs((props) => ({
  half: true,
  color: props.theme.colors[ColorLabels.VISUALS_2],
  size: 200,
  rotate: 180,
}))`
  display: inline-block;
  &:nth-child(1) {
    opacity: 0.6;
  }
`;

const StyledContentContainer = withViewportStyle("div")`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
  gap: ${rem(120)};
  position: relative;

  ${(props) => props.$viewport.tablet`
    gap: ${rem(24)};
    grid-template-columns: 1fr;
  `}

  ${(props) => props.$viewport.mobile`
    grid-template-columns: auto; 
  `}

  .image-primitive {
    max-width: ${rem(512)};
    margin: auto;
    position: relative;
    ${(props) => props.$viewport.tablet`
      max-width: 100%;
    `}
  }
`;

export default function ParagraphPicture(props: Props) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BlockBackgroundColorWrapper
      ref={connect}
      id={nodeId}
      data-testid="paragraph-picture"
    >
      <BlockPaddingWrapper>
        <BlockMaxWidthWrapper>
          <StyledContentContainer>
            {props.children}
            <StyledCircleContainer>
              <StyledCircle />
              <StyledCircle />
            </StyledCircleContainer>
          </StyledContentContainer>
        </BlockMaxWidthWrapper>
      </BlockPaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

ParagraphPicture.craft = {
  isCanvas: true,
  custom: {
    displayName: "Paragraph & Picture",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
